<template>
  <div :style="{ margin: '2rem' }">
    <DialogLoading
      :message="loadingMessage"
      :active="loading"
    />
		<v-card>
      <v-card-title>
        <span class="headline">Cadastro de Profissão no Sienge</span>
      </v-card-title>
			<v-card-text> 
				<v-form
						ref="form"
						v-model="valid"
						lazy-validation
				>
					<v-row>
						<v-col cols="12" sm="6" md="3">
						<v-text-field
								label="Nome"
								maxlength="100"
								required
                :rules="obrigatoryRule"
                v-model="name"
						/>
						</v-col>
					</v-row>
				</v-form>
			</v-card-text>
			<v-card-actions>
          <v-btn color="blue darken-1" :disabled="!valid" text @click="validate">Salvar</v-btn>
			</v-card-actions>
    </v-card>
  </div>
</template>

<script>
import DialogLoading from '@/components/loading/DialogLoading'
import message from '@/utils/message'
import api from '@/services/api'

export default {
  components: {
    DialogLoading
  },
  data: () => ({
    valid: true,
    obrigatoryRule: [
      v => !!v || 'Informação obrigatória'
    ],
    loading: false,
    loadingMessage: 'Carregando',
    name: null
  }),
  methods: {
    validate () {
      if (this.$refs.form.validate()) {
        this.save()
      }
    },
    async save () {
      try {
        this.loading = true
        await api.post('/professions', { name: this.name })
        message.success('Profissão Cadastrada')
      } catch (error) {
        message.error(error.message)
      } finally {
        this.loading = false
        this.name = null
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/professions/FormProfession.vue